
const RegexPhoneNumber = /[0-9]/gi

const ListRole = [
  { id: "ROLE_ADMIN", name: "Admin" },
  { id: "ROLE_NATION", name: "Trung ương" },
  { id: "ROLE_REGION", name: "Miền" },
  { id: "ROLE_PROVINCE", name: "Tỉnh/thành" },
  { id: "ROLE_DISTRICT", name: "Thị trấn" },
  { id: "ROLE_ORGANIZATION", name: "Đơn vị" },
  { id: "ROLE_USER", name: "User" },
  { id: "ROLE_LABORATORY", name: "Phòng xét nghiệm" },
];
const ListMaritalStatus = [
  { value: 0, name: "Độc thân" }, //Single
  { value: 1, name: "Đính hôn" }, //Engaged
  { value: 2, name: "Đã kết hôn" }, //Married
  { value: 3, name: "Ly thân" }, //Separated
  { value: 4, name: "Đã ly hôn" }, //Divorced
];
const ListGender = [
  { id: "M", name: "Nam" },
  { id: "F", name: "Nữ" },
  { id: "U", name: "Không rõ" },
];

const ListSortByDateEncounterDesc = [
  { value: true, name: "Ngày khám gần nhất" }
];

const ListPeson = [
  { id: 1, name: "Người thân" },
  { id: 2, name: "Bệnh nhân" },
  // { id: "3", name: "Bạn" },
];

const ListCountry = [
  { id: "VN", name: "Việt Nam" },
  { id: "TL", name: "Thái Lan" },
  { id: "LA", name: "Lào" },
  { id: "NB", name: "Nhật Bản" },
  { id: "NQ", name: "Hàn Quốc" },
  { id: "TQ", name: "Trung Quốc" },
];

const ListHivStatus = [
  { value: "1", name: "Âm tính" },
  { value: "2", name: "Dương tính" },
  { value: "3", name: "Chờ kết quả" },
];

const PHASE_OF_TREATMENT = [
  { id: "1", name: "Trước điều trị" },
  { id: "2", name: "Đang điều trị" },
  { id: "3", name: "Sau điều trị" },
];

const ListManagerUnit = [
  { id: "1", name: "Bệnh viện phổi Hà Nội" },
  { id: "2", name: "Bệnh viện đa khoa Hà Đông" },
  { id: "3", name: "Bệnh viện đa khoa Sơn Tây" },
  { id: "4", name: "Trại giam Suối Hai" },
  { id: "5", name: "Trại giam Thanh Xuân" },
];

//lý do kết thúc điều trị của lao tiềm ẩn, lao nhạy cảm
const PatientTransferHistoryStatusVT = [
  { id: 1, name: "Khỏi" },
  { id: 2, name: "Hoàn thành" },
  { id: 3, name: "Thất bại" },
  { id: 4, name: "Chết" },
  { id: 5, name: "Không theo dõi được" },
  { id: 6, name: "Không đánh giá" },
  { id: 7, name: "Chuyển điều trị MDR" },
  // { id: 14, name: "Phản ứng bất lợi với thuốc" },
];

//lý do kết thúc điều trị của lao kháng thuốc
const PatientTransferHistoryStatusETB = [
  { id: 1, name: "Khỏi" },
  { id: 8, name: "Bỏ trị" },
  { id: 4, name: "Tử vong" },
  { id: 3, name: "Thất bại" },
  { id: 2, name: "Hoàn thành điều trị" },
  // { id: 9, name: "Chuyển đi" },
  // { id: 10, name: "Thay đổi chẩn đoán" },
  // { id: 11, name: "Phác đồ 4" },
  // { id: 12, name: "Từ chối được điều trị" },
  { id: 6, name: "Không đánh giá" },
  // { id: 13, name: "Khác" }, //10/05/2023 chị Tuyển nhắn ẩn option kết quả điều trị khác
]

const ListRegimen = [
  { id: "1", name: "2SHRZ/6HE" },
  { id: "2", name: "2EHRZ/6HE" },
  { id: "3", name: "2SHRZ/4RH" },
  { id: "4", name: "2SHRZE/1HRZE/5R3H3E3" },
  { id: "5", name: "2RHZ/4RH" },
];

const ListInitialType = [
  { id: "1", name: "Mắc mới" },
  { id: "2", name: "Tái phát" },
  { id: "3", name: "Thất bại" },
  { id: "5", name: "Chuyển đến" },
  { id: "6", name: "Điều trị sau bỏ trị" },
  { id: "7", name: "Khác" },
];

const ListInitialTypeTreatmentPeriod = [
  { id: "1", name: "Mới" },
  { id: "2", name: "Tái phát" },
  { id: "3", name: "Thất bại" },
  // { id: "4", name: "Chuyển đến" },
  { id: "6", name: "Điều trị sau bỏ trị" },
  { id: "7", name: "Khác" },
];

const ListDiagnosis = [
  { id: 1, name: "Lao" },
  { id: 2, name: "Lao đa kháng R/MDR" },
  { id: 3, name: "Lao tiền/siêu kháng" },
  { id: 4, name: "Mycobacteria không lao (NTM)" },
  { id: 5, name: "Khác" },
];

const ListFamilyRelationship = [
  { value: 0, name: "Vợ chồng" },
  { value: 1, name: "Con" },
  { value: 2, name: "Bố mẹ" },
  { value: 3, name: "Anh chị em" },
  { value: 4, name: "Ông bà" },
  { value: 5, name: "Cháu" },
];
const ListHighSchoolEducation = [
  { value: 1, name: "1/12" },
  { value: 2, name: "2/12" },
  { value: 3, name: "3/12" },
  { value: 4, name: "4/12" },
  { value: 5, name: "5/12" },
  { value: 6, name: "6/12" },
  { value: 7, name: "7/12" },
  { value: 8, name: "8/12" },
  { value: 9, name: "9/12" },
  { value: 10, name: "10/12" },
  { value: 11, name: "11/12" },
  { value: 12, name: "12/12" },
  { value: 13, name: "Cấp I" },
  { value: 14, name: "Tốt nghiệp THCS/BTCS" },
  { value: 15, name: "Tốt nghiệp THPT/BTTH" },
];
const ListCivilServantType = [
  { value: 0, name: "Công chức hợp đồng" },
  { value: 1, name: "Công chức được tuyển dụng" },
];
const MedicationType = [
  { value: 1, name: "Thuốc hàng 1" },
  { value: 2, name: "Thuốc hàng 2" },
  { value: 3, name: "Thuốc khác" },
];
const MedicationClassify = [
  { value: 1, name: "Thuốc uống" },
  { value: 2, name: "Thuốc tiêm" },
];
const ListConceptType = [
  { value: 1, name: "Xét nghiệm" }, //LAB_TEST
  { value: 2, name: "Chẩn đoán" }, //DIAGNOSTIC
  { value: 3, name: "Triệu chứng" }, //SYMPTOM
  { value: 4, name: "TÌm kiếm nghiên cứu hình ảnh" }, //IMAGE_STUDY_FINDING
];

const ReasonChangeRegimen = [
  { value: 1, name: "Có thuốc mới" },
  { value: 2, name: "Hết thuốc" },
  // { value: 3, name: "Quy định của bộ y tế" },
  { value: 4, name: "Tác dụng phụ/biến cố bất lợi" },
  { value: 6, name: "Thay đổi chẩn đoán"},
  { value: 5, name: "Lý do khác" },

];
const DiagnosisTBType = [
  { value: 1, name: "Nhóm H nghi lao" },
  { value: 2, name: "Trẻ em nghi lao" },
  { value: 3, name: "Nghi Lao phổi (lao phổi hoặc lao phổi AFB âm)" },
  { value: 4, name: "Nghi Lao ngoài phổi" },
];
const DiagnosisDetailTBType = [
  { value: 1, name: "Lao màng não" },
  { value: 2, name: "Lao màng phổi" },
  { value: 3, name: "Lao hạch" },
  { value: 4, name: "Khác" },
];
const DiagnosisMutilRifampicinTesistantTBType = [
  { value: 1, name: "Thất bại PĐ không kháng R" },
  { value: 2, name: "Nghi lao/NB lao tiếp xúc với NB lao kháng thuốc" },
  { value: 3, name: "Không âm hóa sau 2 hoặc 3 tháng điều trị PĐ không kháng R" },
  { value: 4, name: "Tái phát PĐ không kháng R hoặc PĐ kháng R" },
  { value: 5, name: "Điều trị lại sau bỏ trị PĐ không kháng R hoặc PĐ kháng R" },
  { value: 6, name: "Người bệnh lao mới/H" },
  { value: 7, name: "Người nghi lao có tiền sử điều trị thuốc lao trên 1 tháng" },
  { value: 8, name: "Người bệnh lao phổi mới" },
];
const DiagnosisPreSuperTesistantTBType = [
  { value: 1, name: "Kháng Rifampicin" },
  { value: 2, name: "Nghi thất bại PĐ kháng R/MDR-TB, nuôi cấy (+)" },
  { value: 3, name: "Thất bại PĐ kháng R/MDR-TB" },
];
const AdminitractiveLevel = [
  { value: 1, name: "Cấp trung ương" },
  { value: 2, name: "Cấp vùng/miền" },
  { value: 3, name: "Cấp Tỉnh/Thành phố" },
  { value: 4, name: "Cấp Quận/Huyện" },
  { value: 5, name: "Cấp Xã/Phường" },
];

const HealthOrgOrgType = [
  { name: "ALL", value: 1, display: "Tất cả" },
  { name: "MANAGER", value: 2, display: "Đơn vị quản lý" },
  { name: "TREATMENT", value: 3, display: "Đơn vị điều trị" },
  { name: "LABO", value: 4, display: "Phòng xét nghiệm" },
  { name: "STORE", value: 5, display: "Kho"}
];

const ListConceptDataType = [
  { name: "NUMERIC", value: 1 },
  { name: "TEXT", value: 2 },
  { name: "DATE", value: 3 },
  { name: "BOOLEAN", value: 4 },
  { name: "CODED", value: 5 },
];
const DATATYPE_NUMERIC = 1
const DATATYPE_TEXT = 2
const DATATYPE_DATE = 3
const DATATYPE_BOOLEAN = 4
const DATATYPE_CODED = 5

const ListPatientType = [
  { name: "Lao tiềm ẩn", value: 1, moduleName: "Lao tiềm ẩn" },
  { name: "Lao nhạy cảm", value: 2, moduleName: "Lao nhạy cảm"},
  { name: "Lao kháng thuốc", value: 3, moduleName: "Lao kháng thuốc" },
  { name: "Nghi lao", value: 0, moduleName: "Lao tiềm ẩn" },
];
const PATIENT_TYPE_SUSPECTED_PERSON = 0; //Người có nguy cơ nhiễm và mắc lao
const PATIENT_TYPE_LATENT_TB = 1; //Lao tiềm ẩn
const PATIENT_TYPE_SENSITIVE_TB = 2; //Lao nhạy cảm
const PATIENT_TYPE_DRUG_RESISTANT_TB = 3; //Lao kháng thuốc

const ListLabTestResultStatus = [
  { name: "Chưa có kết quả", value: 1 },
  { name: "Có kết quả", value: 2 },
  { name: "Đã lấy mẫu", value: 3 },
];
const ListResultType = [
  { name: "Single", value: 1 },
  { name: "Multiple", value: 2 },
];
const RESULT_TYPE_MULTIPLE = 2;
const ListFormType = [
  { name: "Xét nghiệm", value: 1 },
  { name: "Hình ảnh", value: 2 },
];
const ListConceptTimes = [ //Có thực hiện nhiều lần
  { name: "Single", value: 1 },
  { name: "Multiple", value: 2 },
];
const FORM_TYPE_LABTEST = 1;
const FORM_TYPE_IMAGING_STUDY = 2;
const PATIENT_TRANSFERRED_TO = 4; //Bệnh nhân chuyển đến registerType = 4
const UNTREATED_PATIENT = 1;
const BEING_TREATED = 2; //đang điều trị

const MedicationTreatmentType = [
  { name: "Thuốc điều trị", value: 1 },
  { name: "Thuốc bổ trợ", value: 2 },
];
const HIVStatusType = [
  { name: "Không rõ tình trạng nhiễm HIV (không XN hoặc XN nhưng chưa rõ kết quả) (1)", value: 1 },
  { name: "Không nhiễm HIV (2)", value: 2 },
  { name: "Có nhiễm HIV (3)", value: 3 },
]
const TBTreatmentHistoryType = [
  { name: "Chưa điều trị hoặc điều trị < 1 tháng", value: 1 },
  { name: "Đã điều trị ≥ 1 tháng", value: 2 },
];
const RegimenType = [
  { name: "Các trường hợp Lao thường", value: 1 },
  { name: "Bệnh nhân Lao kháng thuốc", value: 2 },
  { name: "Các bệnh nhân NTM", value: 3 },
];
const ReasonCodeType = [
  { name: "Lao", value: 1 },
  { name: "Lao đa kháng R/MDR", value: 2 },
  { name: "Lao tiền/siêu kháng", value: 3 },
  { name: "Mycobacteria không lao (NTM)", value: 4 },
  { name: "Khác", value: 5 },
  { name: "Theo dõi lao", value: 6 },
];
const PulmonaryTBType = [
  { id: "1", name: "Lao phổi" },
  { id: "2", name: "Lao ngoài phổi" }
];
//đối tượng nghi ngờ MDR
const ObjectSuspectMDR = [
  { id: "1", name: "Thất bại phác đồ II" },
  { id: "2", name: "Bệnh nhân Lao hoặc nghi lao có tiếp xúc với ca bệnh MDR" },
  { id: "3", name: "Thất bại Phác đồ I" },
  { id: "4", name: "Không âm hóa đờm sau 2 hoặc 3 tháng điều trị Phác đồ I hoặc II" },
  { id: "5", name: "Tái phát Phác đồ I hoặc/ và Phác đồ II" },
  { id: "6", name: "Điều trị lại sau bỏ trị Phác đồ I" },
  { id: "7", name: "Bệnh nhân Lao/ HIV (Mới)" },
  { id: "8", name: "Khác" },
  { id: "9", name: "Bệnh nhân Lao mới" },
];
//loại kháng thuốc: dành cho loại bệnh nhân patientType là lao kháng thuốc
const TypeResistance = [
  { value: 1, name: "Kháng RIF" },
  { value: 2, name: "Kháng đa thuốc" },
  // { value: 2, name: "Kháng R/ đa thuốc" },
  { value: 3, name: "Tiền siêu kháng thuốc" },
  { value: 4, name: "Siêu kháng thuốc" },
  { value: 5, name: "Kháng đơn thuốc" },
  { value: 6, name: "Kháng nhiều thuốc" },
];
//mức loại kháng thuốc: dành cho loại bệnh nhân patientType là lao kháng thuốc
const TypeResistanceLevel = [
  { value: 1, name: "Kháng đơn thuốc" },
  { value: 2, name: "Kháng nhiều thuốc" },
  { value: 3, name: "Kháng RIF" },
  { value: 4, name: "Kháng đa thuốc" },
  { value: 5, name: "Tiền siêu kháng thuốc" },
  { value: 6, name: "Siêu kháng thuốc" },
];
//chuẩn đoán
const Diagnostic = [
  { value: 1, name: "Đã xác nhận" },
  { value: 2, name: "Nghi ngờ" },
]
const HealthOrgMedicalType = [
  { name: "Chương trình chống lao", value: 1 },
  { name: "Y tế công", value: 2 },
  { name: "Y tế tư nhân", value: 3 },
]

const HealthOrgLevel = [
  { name: "Trung ương", value: 1 },
  { name: "Miền", value: 2 },
  { name: "Tỉnh/thành", value: 3 },
  { name: "Quận/huyện", value: 4 },
  { name: "Phường/xã", value: 5 },
]

const HealthOrgType = [
  { name: "Bệnh viện", value: 1 },
  { name: "Phòng khám", value: 2 },
  { name: "Trại", value: 3 },
  { name: "Trung tâm", value: 4 },
];

const ADVISE_TEST_HIV_BEFORE_ENCOUNTER = 5
const ADVISE_TEST_HIV_IN_ENCOUNTER = 6
const ADVISETESTHIV = [
  { name: "Không tư vấn", value: 1 },
  { name: "Tư vấn nhưng người bệnh không xét nghiệm HIV", value: 2 },
  { name: "Tư vấn và xét nghiệm HIV nhưng không rõ kết quả xét nghiệm HIV", value: 3 },
  { name: "HIV (-)", value: 4 },
  { name: "Đã có kết quả xét nghiệm HIV(+) trước khi đến khám, đăng ký điều trị lao", value: ADVISE_TEST_HIV_BEFORE_ENCOUNTER },
  { name: "HIV(+) trong quá trình khám, điều trị lao", value: ADVISE_TEST_HIV_IN_ENCOUNTER },
]

const ART = [
  { name: "Không điều trị ARV trước và trong khi điều trị lao", value: 1 },
  { name: "Điều trị ARV trước khi đăng ký điều trị lao", value: 2 },
  { name: "Điều trị ARV trong khi điều trị lao", value: 3 },
]
const CPT = [
  { name: "Không điều trị Cotrimoxazole trước và trong khi điều trị lao", value: 1 },
  { name: "Điều trị Cotrimoxazole trước khi đăng ký điều trị lao", value: 2 },
  { name: "Điều trị Cotrimoxazole trong khi điều trị lao", value: 3 },
]
const REGISTERCLINICOUTPATIENTHIV = [
  { name: "Chưa đăng ký", value: 1 },
  { name: "Đã đăng ký nhưng hiện đã bỏ", value: 2 },
  { name: "Hiện đang đăng ký", value: 3 },
]

const TYPETREATMENT = [
  { name: "Trước điều trị", value: 1 },
  { name: "Trong quá trình điều trị", value: 2 },
]

//trạng thái bệnh phẩm
const LabTestReportPatientStatus = [
  { name: "Nước bọt", value: 1 },
  { name: "Nhầy mủ", value: 2 },
  { name: "Máu", value: 3 },
  { name: "Khác", value: 4 },
]

//đánh giá kết quả(XQ, xn có thể không cần)
const LabTestReportEvaluateResult = [
  { name: "Cải thiện", value: 1 },
  { name: "Tiến triển xấu", value: 2 },
  { name: "Ổn định", value: 3 },
  { name: "Không có dữ liệu để so sánh", value: 4 },
]

//Cách giải quyết chuyển
const SOLUTIONTRANSFER = [
  { name: "Vào viện", value: 1 },
  { name: "Chuyển đơn vị khác", value: 2 },
  { name: "Chuyển nội tỉnh", value: 3 },
  { name: "Chuyển nội bộ", value: 8 },
  { name: "Ngoại trú", value: 4 },
  { name: "Tiến hành thủ thuật", value: 6 },
  { name: "Khám chuyên khoa", value: 7 },
  { name: "Về nhà", value: 5 },
]
//chuyển nội bộ
const SOLUTION_TRANSFER_INTERNAL = 8;
//chuyển đơn vị khác
const SOLUTION_TRANSFER_OTHER_ORG = 2;
//chuyển nội tỉnh
const SOLUTION_TRANSFER_IN_PROVINCE = 3;

//encounter object
const OBJECT = [
  { name: "Thu phí", value: 1 },
  { name: "Miễn phí", value: 2 },
  { name: "Cấp cứu", value: 3 },
]

const PatientHistoryType = [
  { name: "Tiền sử", value: 1 },
  { name: "Bệnh sử", value: 2 },
]


const ContactPersonType = [
  { name: "Công trường/trường học", value: 1 },
  { name: "Cộng đồng", value: 2 },
  { name: "Gia đình", value: 3 },
  { name: "Khác", value: 4 },
  { name: "Nhân viên y tế", value: 5 },
  { name: "Nơi trú ngụ (viện dưỡng lão, chòi lều, trại mồ côi...)", value: 6 },
  { name: "Trại cải tạo", value: 7 },
]

const ContactPersonObjectManagement = [
  { name: "Bắt đầu Hoá dự phòng", value: 1 },
  { name: "Bắt đầu điều trị lao", value: 2 },
  { name: "Tư vấn/làm sáng tỏ", value: 3 },
]
const ENCOUNTERSTAGE = [
  { name: "Trước điều trị", value: 1 },
  { name: "Sau 2,3 tháng", value: 2 },
  { name: "Sau 5 tháng", value: 3 },
  { name: "Cuối liệu trình điều trị", value: 4 },
]

const CONCEPT_MTB_XPERTS_NAME = "MTB định danh và kháng RMP Xpert"

const SYSTEM_CONFIG_MONTH_TREATMENT = "monthTreatment";
const SYSTEM_CONFIG_DEFAULT_MONTH_TREATMENT = 24;
const SYSTEM_CONFIG_NUMBER_DAYS = "numberDaysDefault";
const SYSTEM_CONFIG_DEFAULT_NUMBER_DAYS = 7;

const ListReferralUnitCode = [
  { name: "Tuyến tỉnh", value: 0 },
  { name: "Tuyến huyện", value: 1 },
  { name: "Tuyến xã", value: 2 },
  { name: "Y tế công tham gia CTCL", value: 3 },
  { name: "Y tế tư nhân", value: 4 }
]
const REFERRAL_UNIT_CODE_COME_ALONE = 4;

const ListAppointmentStatus = [
  { name: "Sớm hơn lịch hẹn", value: 1 },
  { name: "Đúng hẹn", value: 2 },
  { name: "Trễ hẹn", value: 3 },
]

const ListConceptTypeTest = [
  { name: "Soi đờm trực tiếp (AFB)", value: 1 },
  { name: "Xpert MTB/RIF test", value: 2 },
  { name: "Nuôi cấy", value: 3 },
  { name: "Kháng sinh đồ", value: 4 },
  { name: "X quang", value: 5 },
  { name: "HIV", value: 6 },
  { name: "Khác", value: 7 },
]
//1- khỏi, 2- hoàn thành điều trị, 3- thất bại, 4- bỏ trị, 5- thay đổi phác đồ, 6- chuyển đi, 7- không rõ,8- khác
const ListResultPatientPreviousTreatmentHistory = [
  { name: "Khỏi", value: 1 },
  { name: "Hoàn thành điều trị", value: 2 },
  { name: "Thất bại", value: 3 },
  { name: "Bỏ trị", value: 4 },
  { name: "Thay đổi phác đồ", value: 5 },
  { name: "Chuyển đi", value: 6 },
  { name: "Không rõ", value: 7 },
  { name: "Khác", value: 8 },
]

const ListPatientTransferType = [
  { name: "BN đến khám và chưa đăng ký ĐT", value: 1 },
  { name: "BN đang điều trị", value: 2 },
  { name: "Chuyển đến", value: 3 },
  { name: "Chuyển đi", value: 4 },
  { name: "Chuyển LKT", value: 7 },
  { name: "Chưa khai thác thông tin NTX", value: -1}
]
const DictionarySytemObjectRef = [
  { id: "requestType", name: "Loại xét nghiệm" },
  { id: "prehistoric", name: "Biến cố sử dụng thuốc" },
  { id: "pathological", name: "Loại bệnh lý" },
  { id: "severityOfEvent", name: "Mức độ nghiêm trọng của biến cố" },
  { id: "handleIncident", name: "Cách xử trí biến cố" },
  { id: "groupMedication", name: "Các nhóm thuốc" },
  { id: "historyOfDrugAllergy", name: "Tiền sử dị ứng thuốc" },
  { id: "clinicalStatus", name: "Tình trạng lâm sàng" },
  { id: "solutionTransfer", name: "Cách giải quyết/chuyển" },
  { id: "routeOfUsed", name: "Đường dùng" }
];
const SearchObjectRef = ["prehistoric", "historyOfDrugAllergy"]
const RegisterType = [
  { id: 1, name: "Mắc mới" },
  { id: 2, name: "Tái phát" },
  { id: 3, name: "Thất bại" },
  { id: 4, name: "Chuyển đi" },
  { id: 5, name: "Chuyển đến" },
  { id: 6, name: "Điều trị sau bỏ trị" },
  { id: 7, name: "Khác" },

];
const PositionSickType = [
  { id: 1, name: "Phổi" },
  { id: 2, name: "Ngoài phổi" },
  { id: 3, name: "Cả hai" },
  { id: 4, name: "Không rõ" }
];
const TestedHIV = [
  { id: 1, name: "Có" },
  { id: 2, name: "Không" },
  { id: 3, name: "Không rõ" },
];
const defaultPaginations = {
  pageIndex: 1
}
const TIMES_MULTIPLE = 2;
const ListMTBResistant = [
  { value: "1", name: "MTB" },
  { value: "2", name: "Không có MTB" },
]
const ListTerm = [
  { value: 1, name: "Ngắn hạn" },
  { value: 2, name: "Dài hạn" },
]
const customRegimenList = [
  { value: true, name: "Phác đồ riêng" }
]
const TypeBook = [
  { value: 1, name: "Sổ thăm khám" },
  { value: 2, name: "Sổ điều trị" },
  { value: 3, name: "Người tiếp xúc" }
]
const AdviseTestHIV = [
  { name: "Âm tính", value: 1 },
  { name: "Dương tính", value: 2 },
  { name: "Chờ kết quả", value: 3 },
]
const LIST_BOOLEAN = [
  { name: "Có", value: true },
  { name: "Không", value: false },
]
const ListCountryNationality = [
  { name: "Việt Nam", value: 1 },
  { name: "Nước ngoài", value: 2 },
]
const ListEncounterReferralUnitCode = [
  { name: "Hệ thống CTCL (1)", value: 1 },
  { name: "Y tế công tham gia CTCL (2)", value: 2 },
  { name: "Y tế tư (3)", value: 3 },
  { name: "Tự đến (4)", value: 4 },
  { name: "ACIS (5)", value: 5 },
]
const ListKindOfPapers = [
  { name: "Visa", value: 1 },
  { name: "Số hộ chiếu", value: 2 },
  { name: "Giấy thông hành", value: 3 },
]
const CheckBox = [
  { name: "Có", value: "true" },
  { name: "Không", value: "false" },
]

const RelatedPersonType = [
  { name: "Công trường/trường học", value: 1 },
  { name: "Cộng đồng", value: 2 },
  { name: "Gia đình", value: 3 },
  { name: "Nhân viên y tế", value: 4 },
  { name: "Nơi trú ngụ", value: 5 },
  { name: "Trại cải tạo(Viện dưỡng lão, chòi lều, trại mồ côi,...)", value: 6 },
  { name: "Khác", value: 7 }
]

const RelatedPersonRelationShip = [
  { name: "Cha", value: 1 },
  { name: "Con", value: 2 },
  { name: "Mẹ", value: 3 },
  { name: "Chồng", value: 4 },
  { name: "Vợ", value: 5 },
  { name: "Anh", value: 6 },
  { name: "Chị", value: 7 },
  { name: "Em", value: 8 },
  { name: "Ông", value: 9 },
  { name: "Bà", value: 10 },
  { name: "Cháu", value: 11 },
  { name: "Cô", value: 12 },
  { name: "Dì", value: 13 },
]

const RelatedPersonObjectManagement = [
  { name: "Bắt đầu hóa dự phòng", value: 1 },
  { name: "Bắt đầu điều trị lao", value: 2 },
  { name: "Tư vấn/ Làm sáng tỏ", value: 3 },
]

const Report01Type = [
  { value: 1, name: "Tổng số phát hiện" },
  { value: 2, name: "<15 tuổi" },
  { value: 3, name: "Nữ" },
  { value: 4, name: "HIV+" },
]

const ReportADSMType = [
  { value: 1, name: "NB RR/MDR - TB phác đồ ngắn hạn ADSM1" },
  { value: 2, name: "NB RR/MDR - TB phác đồ dài  hạn ADSM1" },
  { value: 3, name: "NB preXDR/XDR-TB ADSM1" },
  { value: 4, name: "NB XDR-TB ADSM1" },
  { value: 5, name: "Tổng ADSM1" },
  { value: 6, name: "NB RR/MDR - TB phác đồ ngắn hạn ADSM2" },
  { value: 7, name: "NB RR/MDR - TB phác đồ dài  hạn ADSM2" },
  { value: 8, name: "NB preXDR/XDR-TB ADSM2" },
  { value: 9, name: "NB XDR-TB ADSM2" },
  { value: 10, name: "Tổng ADSM2" },
  { value: 11, name: "Tổng số biến cố bất lợi" },
  { value: 12, name: "Số lượng biến cố nghiêm trọng" },
  { value: 13, name: "Số lượng biến cố được xử trí liên quan đến thay đổi phác đồ lao" }
]

const Report02Type = [
  // { value: 1, name: "Tổng số thu nhận" },
  // { value: 2, name: "<15 tuổi" },
  // { value: 3, name: "Nữ" },
  // { value: 4, name: "HIV + đang điều trị ARV" },
  // { value: 5, name: "HIV + không điều trị ARV" },
  // { value: 6, name: "NB RR/MDR-TB phác đồ ngắn hạn" },
  // { value: 7, name: "NB RR/MDR-TB phác đồ dài hạn" },
  // { value: 8, name: "NB tiền siêu kháng thuốc (pre XDR-TB)" },
  // { value: 9, name: "NB siêu kháng thuốc (XDR-TB)" },
  // { value: 10, name: "NB kháng đơn/kháng nhiều thuốc" },
  { value: 1, name: "NB RR/MDR-TB phác đồ ngắn hạn" },
  { value: 2, name: "NB RR/MDR-TB phác đồ dài hạn" },
  { value: 3, name: "NB tiền siêu kháng thuốc (pre XDR-TB)" },
  { value: 4, name: "NB siêu kháng thuốc (XDR-TB)" },
  { value: 5, name: "NB kháng đơn/kháng nhiều thuốc" },
  { value: 6, name: "Tổng số thu nhận", type: "total" },
  { value: 7, name: "Trong đó:", type: "in" },
  { value: 8, name: "<15 tuổi" },
  { value: 9, name: "Nữ" },
  { value: 10, name: "HIV + đang điều trị ARV" },
  { value: 11, name: "HIV + không điều trị ARV" },
]

const Report02Type2 = [
  { value: 1, name: "NB thu nhận tại ĐV báo cáo" },
  { value: 2, name: "NB tỉnh lân cận điều trị giai đoạn đầu tại ĐV báo cáo" },
  // { value: 3, name: "NB báo cáo bổ sung" },
]

const Report04Type = [
  { value: 1, name: "Tổng số NB" },
  { value: 2, name: "NB Lao kháng R/đa kháng thuốc (RR/MDR-TB) phác đồ dài hạn" },
  { value: 3, name: "NB Lao kháng R/đa kháng thuốc (RR/MDR-TB) phác đồ ngắn hạn" },
  { value: 4, name: "NB Lao tiền kháng thuốc (pre XDR-TB)" },
  { value: 5, name: "NB Lao siêu kháng thuốc (XDR-TB)" },
  { value: 6, name: "NB kháng đơn/kháng nhiều thuốc" },
  // { value: 7, name: "Báo cáo bổ sung **" },
]

const Report05Type = [
  { value: 2, name: "NB Lao kháng R/đa kháng thuốc (RR/MDR-TB) phác đồ dài hạn" },
  { value: 3, name: "NB Lao kháng R/đa kháng thuốc (RR/MDR-TB) phác đồ ngắn hạn" },
  { value: 4, name: "NB Lao tiền siêu kháng thuốc (pre XDR-TB)" },
  { value: 5, name: "NB Lao siêu kháng thuốc (XDR-TB)" },
  { value: 6, name: "NB kháng đơn/kháng nhiều thuốc" },
  { value: 7, name: "Tổng số NB" },
  // { value: 7, name: "Báo cáo bổ sung **" },
  { value: 8, name: "NB Lao nhạy cảm có PƯBL với thuốc lao hàng 1" },
]

const HIVLabTestOptions = [
  { name: "Không tư vấn", value: 1 },
  { name: "Tư vấn nhưng không xét nghiệm", value: 2 },
  { name: "Tư vấn và xét nghiệm", value: 3 },
]

const ConceptAnswer2Type = [
  // { name: "Nồng độ", value: 1 },
  { name: "Có sử dụng MTB", value: 2 },
  { name: "Môi trường lỏng", value: 3 },
  { name: "Môi trường đặc", value: 4 },
]

const ListType = [
  { name: "Tuần", value: 1 },
  { name: "Tháng", value: 2 }
]

const ListTypeEnvironment = [
  { name: "Môi trường lỏng", value: 3 },
  { name: "Môi trường đặc", value: 4 },
]

//Chỉ dành cho Lao Kháng thuốc
const StatusADSM = [
  { name: "Hoàn thiện", value: 1 },
  { name: "Chưa hoàn thiện", value: 2 },
]

const PatientSearchWatchBy = [
  { value: 1, name: "Ngày khám bệnh" },
  { value: 2, name: "Ngày bắt đầu ĐT" },
  { value: 3, name: "Ngày đăng ký ĐT" },
  { value: 4, name: "Ngày hẹn khám" },
]

const TypeTimeReport = [
  { value: 1, name: "Khoảng thời gian" },
  { value: 2, name: "Tháng" },
  { value: 3, name: "Quý" },
]

const ListRouteOfUsed = [
  { value: "Uống", name: "Uống" },
  { value: "Tiêm tĩnh mạch", name: "Tiêm tĩnh mạch" },
  { value: "Tiêm bắp", name: "Tiêm bắp" },
]

const ReportSourceSearch = [
  { value: 1, name: "Báo cáo đầu vào", trans_key: "search.fromInputReport" },
  { value: 2, name:  "Từ ca bệnh", trans_key: "search.fromTheCase" },
];

const ListChoose = [
  { value: 1, name: "Khoảng thời gian bất kỳ" },
  { value: 2, name: "Quý" },
  // { value: 2, name: "Tháng" },
]

const REPORT_VIEW_LEVEL = [
  {value: 1, name: "Tỉnh"},
  {value: 2, name: "Đơn vị"}
]

const ObjectClassification = [
  { value: 1, name: "Thường quy" },
  { value: 2, name: "Sàng lọc chủ động" },
]

const EtbListTestsWaitingForResultsStatus = [
  { value: 1, name: "Chờ kết quả" },
  { value: 2, name: "Đã có kết quả" },
]

const NotificationType = [
  { value: 1, name: "Chờ tiếp nhận" },
  { value: 2, name: "Chờ kết quả" },
  { value: 3, name: "Kháng R chưa làm  xét nghiệm PLA hàng 2" },
  { value: 4, name: "Tái khám không đầy đủ" },
  { value: 5, name: "Kháng r chưa hoàn thành adsm" },
  { value: 6, name: "Xét nghiệm siêu kháng LPA với item Fluoroquinolones giá trị là kháng mà không dùng 1 trong 3 phác đồ: E1, E2" },
  { value: 7, name: "Xét nghiệm nuôi cấy tháng thứ 4 dương tính chưa làm xét nghiệm kháng sinh đồ" },
  { value: 8, name: "Có lịch khám hôm nay" }
]

const DayOfWeek = [
  { value: 0, name: "CN" },
  { value: 1, name: "T2" },
  { value: 2, name: "T3" },
  { value: 3, name: "T4" },
  { value: 4, name: "T5" },
  { value: 5, name: "T6" },
  { value: 6, name: "T7" },
]

const ListStatusADSM = [
  { value: 1, name: "Hoàn thiện" },
  { value: 2, name: "Chưa hoàn thiện" }
]

const ListEncounterType = [
  { value: 0, name: "Lần khám bổ sung" },
  { value: 1, name: "Lần khám đột xuất" }
]

const LOCAL_STORAGE_CREATE_PATIENT_KEY = "patient_create_temp"
const LOCAL_STORAGE_CREATE_ENCOUNTER_KEY = "encounter_create_temp"
const LOCAL_STORAGE_MEMO_UNIT_KEY = "memo_unit_other_test"
const LOCAL_STORAGE_CREATE_PERIOD_KEY = "period_create_temp"

const REGEX_SPECIAL_CHARACTERS = /^[^<>{}^$`~]*$/

const MAX_FILE_SIZE = 10485760 //10MB

const ACTIVITY_LOG = [
  { value: 0, name: "Xem" },
  { value: 1, name: "Tạo mới" },
  { value: 2, name: "Sửa" },
  { value: 3, name: "Xóa" },
  { value: 4, name: "Ghi hoặc cập nhật" },
  { value: 5, name: "Đăng nhập" },
  { value: 6, name: "Xuất dữ liệu" },
  { value: 7, name: "TbCenter đến Vitimes" },
  { value: 8, name: "Vitimes đến TbCenter" },
  { value: 9, name: "TBControl đến Vitimes" },
  { value: 10, name: "Vitimes đến TBControl" },
]

const TB_TYPE = [
  { value: 1, name: "Lao tiềm ẩn" },
  { value: 2, name: "Lao nhạy cảm" },
  { value: 3, name: "Lao kháng thuốc" },
  { value: 4, name: "Nghi lao" },
]

const ListYear = [...Array((new Date().getFullYear() - 2000))].map((e, i) => {
  const year = new Date().getFullYear() - i;
  return { value: year, name: year }
})

const ListYear1900 = [...Array((new Date().getFullYear() - 1900))].map((e, i) => {
  const year = new Date().getFullYear() - i;
  return { value: year, name: year }
})

const ListQuarter = [
  { value: 1, name: "I" },
  { value: 2, name: "II" },
  { value: 3, name: "III" },
  { value: 4, name: "IV" },
];
const ChoicePatientType = [
  { name: "Tất cả", value: 1 },
  { name: "LNC", value: 2 },
  { name: "LKT", value: 3 },
]

const PhoneRegExp = /((^(84|0){1})(2|3|5|7|8|9))+([0-9]{8})$|((^(01|02){1}))+([0-9]{9})$/;

const ListChooseDashboard = [
  { value: 1, name: "Khoảng thời gian bất kỳ", trans_key: "search.time" },
  { value: 4, name: "Năm", trans_key: "search.year" },
]

const BACTERIAL_EVIDENCE = [
  { value: "1", name: "Có" },
  { value: "2", name: "Không" },
];

const LIST_ORG_FROM_OTHER_SYSTEM = [
  {value: 1, name: "ZTV"},
  {value: 2, name: "HIS-BVPTW"},
  {value: 3, name: "HANOI-TEST"},
  {value: 4, name: "ACF-ACIS"},
  {value: 5, name: "PPM-BacGiang"},
  {value: 6, name: "PPM-BacNinh"},
  {value: 7, name: "PPM-CanTho"}
]

const VTM_STATUS = [
  {value: 1, name: "Chờ phản hồi"},
  {value: 2, name: "Đã tiếp nhận"},
  {value: 3, name: "Từ chối"}
]

const REGIMEN_STATUS = [
  { value: 1, name: "Đang sử dụng" },
  { value: 2, name: "Không còn sử dụng" },
]

const LTBI_TREATMENT_RESULT = [
  { name: "Hoàn tất liệu trình điều trị", value: 1 },
  { name: "Thất bại", value: 2 },
  { name: "Tử vong", value: 3 },
  { name: "Bỏ trị", value: 4 },
  { name: "Ngừng điều trị do độc tính của thuốc", value: 5 },
  { name: "Không đánh giá", value: 6 },
]

const MODULE_LOG = [
  { name: "NNCNVML", value: PATIENT_TYPE_SUSPECTED_PERSON },
  { name: "Lao tiềm ẩn", value: PATIENT_TYPE_LATENT_TB },
  { name: "Lao nhạy cảm", value: PATIENT_TYPE_SENSITIVE_TB },
  { name: "Lao kháng thuốc", value: PATIENT_TYPE_DRUG_RESISTANT_TB },
]

const LocalConst = Object.freeze({
  //ROOT_PATH : "/egret/",
  ListRole: ListRole,
  ListGender: ListGender,
  CheckBox: CheckBox,
  ListSortByDateEncounterDesc: ListSortByDateEncounterDesc,
  ListPeson: ListPeson,
  ListInitialType: ListInitialType,
  ListInitialTypeTreatmentPeriod: ListInitialTypeTreatmentPeriod,
  customRegimenList: customRegimenList,
  ListHivStatus: ListHivStatus,
  ListCountry: ListCountry,
  ListChoose: ListChoose,
  ListDiagnosis: ListDiagnosis,
  ListManagerUnit: ListManagerUnit,
  PHASE_OF_TREATMENT: PHASE_OF_TREATMENT,
  ListRegimen: ListRegimen,
  PatientTransferHistoryStatusVT: PatientTransferHistoryStatusVT,
  ListMaritalStatus: ListMaritalStatus,
  ListFamilyRelationship: ListFamilyRelationship,
  ListCivilServantType: ListCivilServantType,
  ListHighSchoolEducation: ListHighSchoolEducation,
  MedicationType: MedicationType,
  MedicationClassify: MedicationClassify,
  ListConceptType: ListConceptType,
  SearchObjectRef: SearchObjectRef,
  HealthOrgOrgType: HealthOrgOrgType,
  ListConceptDataType: ListConceptDataType,
  ListPatientType: ListPatientType,
  ListLabTestResultStatus: ListLabTestResultStatus,
  DATATYPE_NUMERIC: DATATYPE_NUMERIC,
  DATATYPE_TEXT: DATATYPE_TEXT,
  DATATYPE_DATE: DATATYPE_DATE,
  DATATYPE_BOOLEAN: DATATYPE_BOOLEAN,
  DATATYPE_CODED: DATATYPE_CODED,
  ListResultType: ListResultType,
  ListFormType: ListFormType,
  RESULT_TYPE_MULTIPLE: RESULT_TYPE_MULTIPLE,
  ReasonChangeRegimen: ReasonChangeRegimen,
  AdminitractiveLevel: AdminitractiveLevel,
  FORM_TYPE_LABTEST: FORM_TYPE_LABTEST,
  FORM_TYPE_IMAGING_STUDY: FORM_TYPE_IMAGING_STUDY,
  PATIENT_TRANSFERRED_TO: PATIENT_TRANSFERRED_TO,
  UNTREATED_PATIENT: UNTREATED_PATIENT,
  BEING_TREATED: BEING_TREATED,
  MedicationTreatmentType: MedicationTreatmentType,
  RegimenType: RegimenType,
  ReasonCodeType: ReasonCodeType,
  PulmonaryTBType: PulmonaryTBType,
  ObjectSuspectMDR: ObjectSuspectMDR,
  TypeResistance: TypeResistance,
  Diagnostic: Diagnostic,
  TBTreatmentHistoryType: TBTreatmentHistoryType,
  DEFAULT_PAGINATIONS: defaultPaginations,
  HIVStatusType: HIVStatusType,
  HealthOrgMedicalType: HealthOrgMedicalType,
  HealthOrgLevel: HealthOrgLevel,
  HealthOrgType: HealthOrgType,
  DiagnosisTBType: DiagnosisTBType,
  DiagnosisDetailTBType: DiagnosisDetailTBType,
  DiagnosisMutilRifampicinTesistantTBType: DiagnosisMutilRifampicinTesistantTBType,
  DiagnosisPreSuperTesistantTBType: DiagnosisPreSuperTesistantTBType,
  ADVISETESTHIV: ADVISETESTHIV,
  ART: ART,
  CPT: CPT,
  REGISTERCLINICOUTPATIENTHIV: REGISTERCLINICOUTPATIENTHIV,
  TYPETREATMENT: TYPETREATMENT,
  LabTestReportPatientStatus: LabTestReportPatientStatus,
  LabTestReportEvaluateResult: LabTestReportEvaluateResult,
  SOLUTIONTRANSFER: SOLUTIONTRANSFER,
  OBJECT: OBJECT,
  PatientHistoryType: PatientHistoryType,
  ContactPersonType: ContactPersonType,
  ContactPersonObjectManagement: ContactPersonObjectManagement,
  ENCOUNTERSTAGE: ENCOUNTERSTAGE,
  CONCEPT_MTB_XPERTS_NAME: CONCEPT_MTB_XPERTS_NAME,
  PATIENT_TYPE_SUSPECTED_PERSON,
  PATIENT_TYPE_LATENT_TB: PATIENT_TYPE_LATENT_TB,
  PATIENT_TYPE_SENSITIVE_TB: PATIENT_TYPE_SENSITIVE_TB,
  PATIENT_TYPE_DRUG_RESISTANT_TB: PATIENT_TYPE_DRUG_RESISTANT_TB,
  PatientTransferHistoryStatusETB: PatientTransferHistoryStatusETB,
  SYSTEM_CONFIG_DEFAULT_MONTH_TREATMENT: SYSTEM_CONFIG_DEFAULT_MONTH_TREATMENT,
  SYSTEM_CONFIG_MONTH_TREATMENT: SYSTEM_CONFIG_MONTH_TREATMENT,
  ListReferralUnitCode: ListReferralUnitCode,
  ListAppointmentStatus: ListAppointmentStatus,
  REFERRAL_UNIT_CODE_COME_ALONE: REFERRAL_UNIT_CODE_COME_ALONE,
  SYSTEM_CONFIG_NUMBER_DAYS: SYSTEM_CONFIG_NUMBER_DAYS,
  SYSTEM_CONFIG_DEFAULT_NUMBER_DAYS: SYSTEM_CONFIG_DEFAULT_NUMBER_DAYS,
  ListConceptTypeTest: ListConceptTypeTest,
  ListResultPatientPreviousTreatmentHistory: ListResultPatientPreviousTreatmentHistory,
  ListPatientTransferType: ListPatientTransferType,
  DictionarySytemObjectRef: DictionarySytemObjectRef,
  ListConceptTimes: ListConceptTimes,
  TIMES_MULTIPLE: TIMES_MULTIPLE,
  RegisterType: RegisterType,
  PositionSickType: PositionSickType,
  TestedHIV: TestedHIV,
  ListMTBResistant: ListMTBResistant,
  ListTerm: ListTerm,
  TypeBook: TypeBook,
  ADVISE_TEST_HIV_BEFORE_ENCOUNTER,
  ADVISE_TEST_HIV_IN_ENCOUNTER,
  AdviseTestHIV: AdviseTestHIV,
  LIST_BOOLEAN: LIST_BOOLEAN,
  ListCountryNationality: ListCountryNationality,
  ListEncounterReferralUnitCode: ListEncounterReferralUnitCode,
  ListKindOfPapers: ListKindOfPapers,
  RelatedPersonType: RelatedPersonType,
  RelatedPersonRelationShip: RelatedPersonRelationShip,
  RelatedPersonObjectManagement: RelatedPersonObjectManagement,
  Report01Type: Report01Type,
  Report02Type: Report02Type,
  Report02Type2: Report02Type2,
  Report04Type: Report04Type,
  Report05Type: Report05Type,
  HIVLabTestOptions: HIVLabTestOptions,
  ConceptAnswer2Type: ConceptAnswer2Type,
  ListType: ListType,
  ListTypeEnvironment: ListTypeEnvironment,
  StatusADSM: StatusADSM,
  PatientSearchWatchBy: PatientSearchWatchBy,
  TypeTimeReport: TypeTimeReport,
  ListRouteOfUsed: ListRouteOfUsed,
  ReportSourceSearch: ReportSourceSearch,
  ObjectClassification: ObjectClassification,
  regexPhoneNumber: RegexPhoneNumber,
  EtbListTestsWaitingForResultsStatus: EtbListTestsWaitingForResultsStatus,
  NotificationType: NotificationType,
  DayOfWeek: DayOfWeek,
  ListStatusADSM: ListStatusADSM,
  ListEncounterType: ListEncounterType,
  LOCAL_STORAGE_CREATE_PATIENT_KEY: LOCAL_STORAGE_CREATE_PATIENT_KEY,
  LOCAL_STORAGE_CREATE_ENCOUNTER_KEY: LOCAL_STORAGE_CREATE_ENCOUNTER_KEY,
  LOCAL_STORAGE_CREATE_PERIOD_KEY: LOCAL_STORAGE_CREATE_PERIOD_KEY,
  REGEX_SPECIAL_CHARACTERS: REGEX_SPECIAL_CHARACTERS,
  LOCAL_STORAGE_MEMO_UNIT_KEY: LOCAL_STORAGE_MEMO_UNIT_KEY,
  MAX_FILE_SIZE: MAX_FILE_SIZE,
  ACTIVITY_LOG: ACTIVITY_LOG,
  SOLUTION_TRANSFER_INTERNAL: SOLUTION_TRANSFER_INTERNAL,
  TB_TYPE: TB_TYPE,
  ListYear,
  ListYear1900,
  ListQuarter,
  PhoneRegExp: PhoneRegExp,
  REPORT_VIEW_LEVEL,
  ChoicePatientType,
  SOLUTION_TRANSFER_OTHER_ORG,
  SOLUTION_TRANSFER_IN_PROVINCE,
  ReportADSMType,
  ListChooseDashboard,
  BACTERIAL_EVIDENCE,
  LIST_ORG_FROM_OTHER_SYSTEM,
  VTM_STATUS,
  REGIMEN_STATUS,
  TypeResistanceLevel: TypeResistanceLevel,
  LTBI_TREATMENT_RESULT,
  MODULE_LOG
});
export default LocalConst;